import { useCallback, useEffect, useRef, useState } from 'react';

export function useHeroPlayKey(isHeroVisible: boolean) {
  const [playKey, setPlayKey] = useState(0);
  const wasVisible = useRef(false);

  useEffect(() => {
    if (isHeroVisible && !wasVisible.current) {
      setPlayKey(k => k + 1);
    }
    wasVisible.current = isHeroVisible;
  }, [isHeroVisible]);

  const restart = useCallback(() => {
    if (!wasVisible.current) return;
    setPlayKey(k => k + 1);
  }, []);

  return { playKey, restart };
}
